<template>
  <div>
    <div v-show="loaded">
      <multiselect v-model="cpvCode" v-bind:disabled="disabled" :options="cpvCodes" track-by="code" openDirection="bottom" :clear-on-select="false" :close-on-select="true" :searchable="true" :custom-label="customLabel" placeholder="Vyberte CPV kód" />
    </div>
    <div v-show="!loaded">
      Načítavam CPV kódy
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'MainCpvCodeSelect',
  components: {Multiselect},
  props: {
    value: String,
    disabled: false
  },
  data: function () {
    return {
      loaded: false,
      cpvCode: null,
      cpvCodes: []
    }
  },
  watch: {
    cpvCode (value) {
      if (value && value.cpv) {
        this.$emit('input', value.cpv)
      } else {
        this.$emit('input', '')
      }
    }
  },
  methods: {
    customLabel ({cpv, sk}) {
      return `${sk} - (${cpv})`
    },
    clear () {
      this.cpvCode = null
    }
  },
  async mounted () {
    var vm = this
    var codes = JSON.parse(localStorage.getItem('CPV_CODES_MAIN'))
    if (codes != null) {
      vm.cpvCodes = codes
      vm.loaded = true
    } else {
      await this.$transparexHttp.get('/cpv-codes').then(function (response) {
        localStorage.setItem('CPV_CODES_MAIN', JSON.stringify(response.data))
        vm.cpvCodes = response.data
        vm.loaded = true
      })
    }
    if (this.value) {
      this.cpvCode = this.cpvCodes.find(cpvCode => cpvCode.code === this.value)
    }
  }
}
</script>
